import { CheckListTaskEntity } from 'backend-entity';

export interface CrmPatchCheckListTaskSaveStageRequestDto {
  result: CheckListTaskEntity['result'];
}
